<template>
    <ion-content :force-overscroll="forceOverscroll" class="mb-0 px-0" :class="{ 'pa-0': noPadding }">
        <div slot="fixed" class="full-width">
            <ContentFixedNotification />
        </div>
        <ion-row class="ion-justify-content-center background-color">
            <ion-col v-if="!loading" size="12" size-sm="12" size-lg="10" size-xl="8" class="px-0" :class="{ 'pa-0': noPadding }">
                <back-button v-if="backBtn && !isNative" :backText="backText" class="back-btn" />
                <div class="content">
                    <slot />
                </div>
            </ion-col>
            <ion-col v-else size="1" class="ion-text-center ion-align-items-center d-flex" style="height: 50vh">
                <ion-spinner name="lines-small" class="full-height full-width" />
            </ion-col>
        </ion-row>
        <slot name="footer" />
    </ion-content>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonRow, IonCol, IonContent, IonSpinner } from '@ionic/vue';
import { useStore } from 'vuex';
import backButton from '@/components/backButton.vue';
import ContentFixedNotification from '@/components/ContentFixedNotification.vue';

export default defineComponent({
    components: { ContentFixedNotification, IonRow, IonCol, backButton, IonContent, IonSpinner },
    props: {
        backBtn: Boolean,
        backText: String,
        noPadding: Boolean,
        ionConent: Boolean,
        loading: Boolean,
        forceOverscroll: { type: Boolean, Default: true },
    },
    setup() {
        const store = useStore();
        const isNative = computed(() => store.getters.isNative);
        return { isNative };
    },
});
</script>

<style scoped>
@media screen and (min-width: 960px) {
    .background-color {
        background-color: #fafafa;
        min-height: 100%;
    }
}
.back-btn,
.back-btn > * {
    z-index: 5;
}
.content {
    z-index: 4;
}
</style>
